import { render, staticRenderFns } from "./CreateSalesRecord.vue?vue&type=template&id=57f77e54&scoped=true&"
import script from "./CreateSalesRecord.vue?vue&type=script&lang=ts&"
export * from "./CreateSalesRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f77e54",
  null
  
)

export default component.exports